/* eslint-disable import/prefer-default-export */
import { z } from 'zod';

export const buildOrdersFiltersSchema = (t) => z.object({
  sequential_number: z
    .string()
    .optional()
    .refine(
      (value) => !value || /^\d+$/.test(value),
      { message: t('errors.invalid_number', { defaultValue: 'Número inválido' }) }
    ),
  agent_id: z.string().optional().or(z.literal('')),
  created_at: z
    .object({
      startDate: z.any().nullable().optional(),
      endDate: z.any().nullable().optional()
    })
    .nullable()
    .optional()
});
